// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts
import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { SpeedometerIcon } from '@moia-dev/pace-icons'
import { FleetDashboardAreaRoutes } from './FleetDashboardAreaRoutes'

export const FleetDashboardAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={FleetDashboardAreaRoutes.route}
      Icon={SpeedometerIcon}
    />
  )
}
